export default {
  fr: {
    welcome_text: "Bienvenue {name}",
    welcome_description: "Vous êtes {approvedUserCount} membres à {community}.",
  },
  en: {
    welcome_text: "Welcome {name}!",
  },
};
